import { send_icon } from "assets/svg";
import classNames from "classnames";
import Loading from "components/shared/Loading";
import Typography from "components/shared/Typography";
import { useEffect, useRef, useState } from "react";
import { IoMdClose } from "react-icons/io";
import { useChatQueries } from "services";
import MarkdownPreview from "@uiw/react-markdown-preview";
import { GoPlus } from "react-icons/go";
import { offset, useClick, useDismiss, useFloating, useInteractions } from "@floating-ui/react";
import { LuRefreshCcw } from "react-icons/lu";
import Skeleton from "react-loading-skeleton";

interface IChadModalInterface {
  previous_response: string;
  onClose: () => void;
  report_id: string;
  block_id: string;
  setChatSessionId: (value: any) => void;
  handleChatAction: (action: string, message: string) => void;
  chatMessages: ChatItem[];
  setChatMessages: (value: any) => void;
  open: boolean;
  isChatActionDropdownOpen: boolean;
  handleChatActionDropdownOpen: (value: boolean) => void;
  suggestedQuestions: string[];
}

export interface IChatMessages {
  query: string;
  response: any;
}

export interface ChatItem {
  id: number;
  content: string;
  sender: string;
  created: string;
  updated: string;
}

export function Chat(props: IChadModalInterface) {
  const {
    previous_response,
    onClose,
    report_id,
    block_id,
    chatMessages,
    setChatMessages,
    open,
    setChatSessionId,
    handleChatAction,
    handleChatActionDropdownOpen,
    suggestedQuestions,
  } = props;

  useEffect(() => {
    function preventBodyScroll() {
      document.body.style.overflow = "hidden";
    }

    function allowBodyScroll() {
      document.body.style.overflow = "auto";
    }

    if (open) {
      preventBodyScroll();
    } else {
      allowBodyScroll();
    }

    return () => {
      allowBodyScroll();
    };
  }, [open]);

  const [isChatActionDropdownOpen, setIsChatActionDropdownOpen] = useState(false);

  const [query, setQuery] = useState("");
  const [session_id, setSession_id] = useState<string | null>();
  const [isLoading, setIsLoading] = useState(false);
  const [isError, setIsError] = useState(false);
  const [isQueryEmpty, setIsQueryError] = useState(false);
  const [question, setQuestion] = useState("");

  const { chatQuery } = useChatQueries();

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setIsQueryError(false);
    setQuery(e.target.value);
  };

  const myDivRef = useRef<HTMLDivElement>(null);

  const scrollToBottom = () => {
    if (myDivRef.current) {
      myDivRef.current.scrollTop = myDivRef.current.scrollHeight;
    }
  };

  const [currentMessages, setCurrentMessages] = useState<IChatMessages[]>([]);

  const [querySuggestedQuestions, setQuerySuggestedQuestions] = useState<string[]>([]);
  const [renderSuggestedQuestions, setRenderSuggestedQuestions] = useState<string[]>([]);

  const handleSubmit = async () => {
    if (query === "") {
      setIsQueryError(true);
      return;
    }

    setQuestion(query);
    setTimeout(() => {
      scrollToBottom();
    }, 200);
    setIsLoading(true);
    const data = { session_id, query, report_id, block_id };

    const customId = "custom-toast-id";

    setQuery("");
    chatQuery(data, {
      onError: (error, variables, context) => {
        setIsError(true);
        setIsLoading(false);
      },
      onSuccess: (data, variables, context) => {
        const { session_id, content, suggestions } = data.data;
        setSession_id(session_id);
        setIsLoading(false);
        setIsError(false);
        setCurrentMessages((prev: IChatMessages[]) => [...prev, { query, response: content }]);
        setQuerySuggestedQuestions(suggestions);
        setChatSessionId(session_id);
      },
    });
  };

  useEffect(() => {
    const comsuggestedQuestions = querySuggestedQuestions.length > 0 ? querySuggestedQuestions : suggestedQuestions;

    setRenderSuggestedQuestions(comsuggestedQuestions);
  }, [querySuggestedQuestions, suggestedQuestions]);

  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      handleSubmit();
    }
  };

  const handleScroll = (e: any) => {
    let element = e.target;
    if (element.scrollTop === 0) {
      //fetch messages
    }
  };

  console.log(chatMessages, "chatMessages");

  const endRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (chatMessages.length > 0) {
      endRef.current?.scrollIntoView({ behavior: "smooth" });
    }
  }, [chatMessages, open]);

  const { refs, floatingStyles, context } = useFloating({
    open: isChatActionDropdownOpen,
    onOpenChange: setIsChatActionDropdownOpen,
    middleware: [
      offset({
        mainAxis: 6,
      }),
    ],
  });

  const click = useClick(context);

  const { getReferenceProps, getFloatingProps } = useInteractions([click]);

  const [suggestedQuestion, setSuggestedQuestion] = useState("");

  return (
    <div className="h-screen w-full flex flex-col justify-between">
      <div className="border-b-[1px] border-grey-100 px-6 pt-6 pb-4">
        <div className="flex justify-end items-center">
          <div
            aria-label="close"
            className="hover:bg-grey-100 hover:cursor-pointer flex justify-center items-center  rounded-full  h-8 w-8"
            onClick={onClose}
          >
            <IoMdClose className=" h-6 w-6" />
          </div>
        </div>
      </div>
      <div className="flex flex-col h-full overflow-y-scroll no-scrollbar" ref={myDivRef}>
        <div className="w-full">
          {isError && (
            <div className="flex justify-center items-center p-6">
              <div className=" h-full w-[100%] mt-10">
                <Typography variant="displayxs" className="text-center text-grey-500">
                  Error fetching result
                </Typography>{" "}
              </div>
            </div>
          )}
          <div className="gap-6 flex flex-col h-full overflow-y-scroll p-3" onScroll={handleScroll}>
            {chatMessages.length > 0 &&
              ([...chatMessages].reverse() as ChatItem[]).map((message: ChatItem) => (
                <div className="flex flex-col gap-3" key={message.id}>
                  {message.sender === "user" && (
                    <div className="w-full flex justify-end">
                      <div className="px-4 py-3 w-fit bg-primary-50 rounded-lg max-w-[95%]">
                        <Typography variant="textsm" className="text-shade-black">
                          {message?.content}
                        </Typography>{" "}
                      </div>
                    </div>
                  )}
                  {message.sender === "assistant" && (
                    <div className="h-full max-w-[95%] flex justify-start mt-1 ">
                      <div className="bg-primary-100 rounded-lg overflow-auto no-scrollbar  px-4 py-3">
                        <MarkdownPreview
                          source={message?.content}
                          wrapperElement={{
                            "data-color-mode": "light",
                          }}
                          style={{
                            backgroundColor: "#e3e3fc",
                          }}
                        />
                        <ChatAction message={message?.content} handleChatAction={handleChatAction} />
                        {/* <div className="flex justify-end">
                          <div
                            className="flex gap-1 justify-center items-center p-2 bg-shade-white w-auto rounded-2xl mt-8 mb-2 hover:cursor-pointer hover:bg-grey-100"
                            ref={refs.setReference}
                            {...getReferenceProps()}
                          >
                            <GoPlus className="h-5 w-5" />
                            <Typography variant="textxs" className="text-shade-black">
                              Add to Section
                            </Typography>{" "}
                          </div>
                          {isChatActionDropdownOpen && (
                            <div
                              ref={refs.setFloating}
                              style={floatingStyles}
                              {...getFloatingProps()}
                              className={
                                "flex flex-col items-start gap-1 bg-shade-white border-grey-75 border-[1px] rounded-lg w-[176px] py-2 shadow-lg"
                              }
                            >
                              <div
                                className="flex gap-2 justify-start items-center py-2 pl-3  w-full hover:cursor-pointer hover:bg-grey-50"
                                onClick={() => handleChatAction("append_section", message?.content)}
                              >
                                <GoPlus className="h-5 w-5" />
                                <Typography variant="textxs" className="text-shade-black">
                                  Append Section
                                </Typography>{" "}
                              </div>
                              <div
                                className="flex gap-2 justify-start items-center py-2 pl-3 hover:cursor-pointer hover:bg-grey-50 w-full"
                                onClick={() => handleChatAction("replace_section", message?.content)}
                              >
                                <LuRefreshCcw />
                                <Typography variant="textxs" className="text-shade-black">
                                  Replace Section
                                </Typography>{" "}
                              </div>
                            </div>
                          )}
                        </div> */}
                      </div>
                    </div>
                  )}
                </div>
              ))}

            {currentMessages.length > 0 &&
              currentMessages.map((message: IChatMessages) => (
                <div className="flex flex-col gap-3 " key={message.query + Math.random()}>
                  <div className="w-full flex justify-end">
                    <div className="px-4 py-3 w-fit bg-primary-50 rounded-lg max-w-[90%]">
                      <Typography variant="textsm" className="text-shade-black">
                        {message.query}
                      </Typography>{" "}
                    </div>
                  </div>
                  <div className="h-full w-full flex justify-start mt-1 max-w-[95%]">
                    <div className="bg-primary-100 rounded-lg overflow-auto  px-4 py-3">
                      <MarkdownPreview
                        source={message?.response}
                        wrapperElement={{
                          "data-color-mode": "light",
                        }}
                        style={{
                          backgroundColor: "#e3e3fc",
                        }}
                      />
                      {/* <div className="flex justify-end">
                        <div
                          className="flex gap-1 justify-center items-center p-2 bg-shade-white w-auto rounded-2xl mt-8 mb-2 hover:cursor-pointer hover:bg-grey-100"
                          ref={refs.setReference}
                          {...getReferenceProps()}
                        >
                          <GoPlus className="h-5 w-5" />
                          <Typography variant="textxs" className="text-shade-black">
                            Add to Section
                          </Typography>{" "}
                        </div>
                        {isChatActionDropdownOpen && (
                          <div
                            ref={refs.setFloating}
                            style={floatingStyles}
                            {...getFloatingProps()}
                            className={
                              "flex flex-col items-start gap-1 bg-shade-white border-grey-75 border-[1px] rounded-lg w-[176px] py-2 shadow-lg"
                            }
                          >
                            <div
                              className="flex gap-2 justify-start items-center py-2 pl-3  w-full hover:cursor-pointer hover:bg-grey-50"
                              onClick={() => handleChatAction("append_section", message?.response)}
                            >
                              <GoPlus className="h-5 w-5" />
                              <Typography variant="textxs" className="text-shade-black">
                                Append Section
                              </Typography>{" "}
                            </div>
                            <div
                              className="flex gap-2 justify-start items-center py-2 pl-3 hover:cursor-pointer hover:bg-grey-50 w-full"
                              onClick={() => handleChatAction("replace_section", message?.response)}
                            >
                              <LuRefreshCcw />
                              <Typography variant="textxs" className="text-shade-black">
                                Replace Section
                              </Typography>{" "}
                            </div>
                          </div>
                        )}
                      </div> */}

                      <ChatAction message={message?.response} handleChatAction={handleChatAction} />
                    </div>
                  </div>
                </div>
              ))}

            {isLoading && (
              <div className="flex flex-col gap-3">
                <div className="flex justify-end start">
                  <div className="max-w-[95%]">
                    <div className="px-4 py-3 w-fit bg-primary-50 rounded-lg">
                      <Typography variant="textsm" className="text-shade-black">
                        {question}
                      </Typography>{" "}
                    </div>
                  </div>
                </div>
                <div className="flex justify-start items-start">
                  <div className=" h-full w-[95%]  mt-4">
                    <div className="message-indicator">
                      <div className="line"></div>
                      <div className="line"></div>
                      <div className="line"></div>
                    </div>
                  </div>
                </div>{" "}
              </div>
            )}
            <div ref={endRef}></div>
          </div>
        </div>
      </div>

      <div>
        {renderSuggestedQuestions && renderSuggestedQuestions.length > 0 && (
          <div className="px-3 pt-3">
            <div className="flex justify-center mb-3">
              <Typography variant="textxs" className="text-center text-grey-500">
                Suggested Questions:
              </Typography>
            </div>
            <div className="flex flex-wrap gap-2 justify-center">
              {renderSuggestedQuestions?.map((question: string, index: number) => (
                <div
                  className="border-[1px] border-grey-100 py-[6px] px-3 rounded-lg flex justify-center hover:cursor-pointer hover:bg-grey-100"
                  key={index}
                  onClick={() => {
                    setQuery(question);
                    setSuggestedQuestion(question);
                    setIsQueryError(false);
                  }}
                >
                  <Typography variant="textsm" className="text-center text-shade-black">
                    {question}
                  </Typography>
                </div>
              ))}
            </div>
          </div>
        )}

        <div className="relative mt-1 rounded-md p-6 " id="loadingChat">
          <input
            className={classNames(
              "bg-grey-75 py-4 px-3 pl-3  border shadow-sm  placeholder-grey-400 focus:outline-none   block w-full rounded-md sm:text-sm focus:ring-1",
              {
                "focus:border-primary-200 border-grey-300 focus:ring-primary-200": !isQueryEmpty,
                "focus:border-error-500 border-error-300 focus:ring-error-500": isQueryEmpty,
              }
            )}
            disabled={isLoading}
            placeholder="Type here..."
            value={query}
            onChange={(e) => handleChange(e)}
            onKeyDown={handleKeyPress}
            required
          />
          <div className="absolute inset-y-0 right-8 flex items-center hover:cursor-pointer">
            <div
              className="h-10 w-10 rounded-full  border-[1px] border-grey-200 bg-shade-white flex items-center justify-center"
              onClick={() => handleSubmit()}
            >
              <img className="w-6 h-6 text-gray-500 sm:text-sm" alt="send message" src={send_icon} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

interface ChatActionProps {
  message: string;
  handleChatAction: (action: string, message: string) => void;
}
function ChatAction(props: ChatActionProps) {
  const { message, handleChatAction } = props;

  const [isChatActionDropdownOpen, setIsChatActionDropdownOpen] = useState(false);

  const { refs, floatingStyles, context } = useFloating({
    open: isChatActionDropdownOpen,
    onOpenChange: setIsChatActionDropdownOpen,
    middleware: [
      offset({
        mainAxis: 6,
      }),
    ],
  });

  const click = useClick(context);

  const dismiss = useDismiss(context, {
    outsidePressEvent: "mousedown",
  });

  const { getReferenceProps, getFloatingProps } = useInteractions([click, dismiss]);

  return (
    <div className="flex justify-end">
      <div
        className="flex gap-1 justify-center items-center p-2 bg-shade-white w-auto rounded-2xl mt-8 mb-2 hover:cursor-pointer hover:bg-grey-100"
        ref={refs.setReference}
        {...getReferenceProps()}
      >
        <GoPlus className="h-5 w-5" />
        <Typography variant="textxs" className="text-shade-black">
          Add to Section
        </Typography>{" "}
      </div>
      {isChatActionDropdownOpen && (
        <div
          ref={refs.setFloating}
          style={floatingStyles}
          {...getFloatingProps()}
          className={"flex flex-col items-start gap-1 bg-shade-white border-grey-75 border-[1px] rounded-lg w-[176px] py-2 shadow-lg"}
        >
          <div
            className="flex gap-2 justify-start items-center py-2 pl-3  w-full hover:cursor-pointer hover:bg-grey-50"
            onClick={() => {
              setIsChatActionDropdownOpen(false);
              handleChatAction("append_section", message);
            }}
          >
            <GoPlus className="h-5 w-5" />
            <Typography variant="textxs" className="text-shade-black">
              Append Section
            </Typography>{" "}
          </div>
          <div
            className="flex gap-2 justify-start items-center py-2 pl-3 hover:cursor-pointer hover:bg-grey-50 w-full"
            onClick={() => {
              setIsChatActionDropdownOpen(false);
              handleChatAction("replace_section", message);
            }}
          >
            <LuRefreshCcw />
            <Typography variant="textxs" className="text-shade-black">
              Replace Section
            </Typography>{" "}
          </div>
        </div>
      )}
    </div>
  );
}
